import type { ComponentProps } from 'react'
import { cn } from '~/lib/utils'

export const PageWrapper = (props: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('flex flex-col gap-4 pt-4', props.className)}
		style={{ height: 'calc(100vh - 60px)', ...props.style }}
	/>
)

export const ContentWrapper = (props: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('flex flex-1 flex-row overflow-hidden', props.className)}
	/>
)

export const FiltersWrapper = (props: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('flex flex-row items-start gap-4 px-4', props.className)}
	/>
)

export const ListWrapper = ({
	isMapVisible,
	...props
}: ComponentProps<'div'> & { isMapVisible?: boolean }) => (
	<div
		{...props}
		className={cn(
			'w-full overflow-y-scroll px-4 pb-4',
			{ 'hidden md:block md:w-1/2 lg:w-2/3 xl:w-[945px]': isMapVisible },
			props.className,
		)}
	/>
)

export const MapWrapper = ({
	isMapVisible,
	...props
}: ComponentProps<'div'> & { isMapVisible?: boolean }) =>
	isMapVisible ? (
		<div
			{...props}
			className={cn(
				'relative flex flex-1 shrink-0 flex-col pt-[2px]',
				props.className,
			)}
		/>
	) : null
